import React from 'react'
import { cn } from '@/lib/utils'

interface PageContainerProps {
  children: React.ReactNode
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '4xl' | '6xl' | '7xl' | 'page' | 'full'
  padding?: string
  className?: string
  /** When false, skip inner max-width wrapper (canvas / bleed layouts). */
  contained?: boolean
}

/** Horizontal inset responds to the page pane container; full 60px only appears when the pane is wide. */
const defaultPagePadding =
  'px-4 py-4 sm:px-6 sm:py-6 @3card:px-[60px] @3card:py-6'

export function PageContainer({
  children,
  maxWidth = 'page',
  padding = defaultPagePadding,
  className,
  contained = true,
}: PageContainerProps) {
  const maxWidthClass = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '4xl': 'max-w-4xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    page: 'max-w-[1200px]',
    full: 'max-w-full',
  }[maxWidth]

  return (
    <div className={cn('w-full custom-scrollbar', padding, className)}>
      {contained ? (
        <div className={cn('mx-auto space-y-6', maxWidthClass)}>{children}</div>
      ) : (
        children
      )}
    </div>
  )
}
